import {Row, SpinnerLoader} from "components";

interface LoaderProps {}

export const Loader: React.FC<LoaderProps> = () => {
  return (
    <Row justifyContent="center" marginTop={20}>
      <SpinnerLoader />
    </Row>
  );
};
